<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "App",
};
</script>

<style lang="scss">
html,
body,
#app {
  width: 100%;
  height: 100%;
}
body {
  margin: 0px;
}
*{
	margin: 0;
	padding: 0;
}
a {
  text-decoration: none;
   cursor: pointer;
}
a:link {
  color: #9f9f9f;
}
a:visited {
  color: #9f9f9f;
}
a:hover {
  color: #9f9f9f;
}
a:active {
  color: #9f9f9f;
}

/*  */
input:focus{
  outline: none;
}
.clear{
	clear: both;
}

li{
	list-style: none;
}
.el-tabs__item{
	color: #989898;
	font-size: 15px;
}
.el-tabs__item.is-active{
	color: #0A0A0A;
	font-weight: bold;
}
.el-tabs__item:hover{
	color: #0A0A0A;
}
.el-tabs__active-bar{
	background-color: #0A0A0A;
}
.el-input__inner {
   border-radius: 0;

}
.el-form-item__label{
	color: #2d2a2a;
	font-size: 14px;
}
.el-select{
	width: 100%;
}
.mem-jin{
	text-transform: uppercase;
	font-size: 15px;
	font-family: Arial;
	font-weight: 400;
	color: #636363;
	line-height: 40px;
	b{
		color: #0A0A0A;
	}
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /* margin-top: 60px; */
  background: #FFFFFF;
}
</style>
